import { useState } from 'react';
import { useNavigate } from 'react-router';

import { BottomSheet, Button, Card } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import ROUTES from '@/router/routes';

interface Props {
  closeBottomSheet: () => void;
}

const BodyCard = ({ closeBottomSheet }: Props) => {
  return (
    <div className="flex flex-col items-center px-6">
      <p className="text-black text-lg font-bold lg:hidden">
        Revisá tu casilla
      </p>
      <p className="text-sm text-center mt-6 font-medium text-gdt-gray">
        Te enviamos un mail con la información para recuperar tu cuenta.
        Verificá en tu casilla de correo y seguí jugando a Gran DT.
      </p>
      <Button
        className="w-full mt-9 lg:max-w-xs"
        id="btnAccept"
        type="button"
        variant="primary"
        onClick={() => closeBottomSheet()}
      >
        Aceptar
      </Button>
    </div>
  );
};

export const SendEmailSuccess = () => {
  const [open, setOpen] = useState(false);
  const { isDesktop } = useIsDesktop();
  const navigate = useNavigate();

  const handleSheet = () => {
    navigate(ROUTES.basePath);
  };

  return isDesktop ? (
    <Card title="Revisá tu casilla">
      <BodyCard closeBottomSheet={handleSheet} />
    </Card>
  ) : (
    <BottomSheet
      closeOutside={false}
      isOpen={!open}
      showCloseButton={false}
      onClose={() => setOpen(!open)}
    >
      <BodyCard closeBottomSheet={handleSheet} />
    </BottomSheet>
  );
};
